import { Story } from '@app/components/Risk/types'
import { fetchStories } from '../services/storiesService'
import { atomWithQuery } from 'jotai-tanstack-query'

export const storiesAtom = atomWithQuery<Story[]>(() => ({
  queryKey: ['stories'],
  queryFn: fetchStories,
}))
